import React from 'react'
import { AdminPanelPage } from '../AdminPanelPage'
import { Button, Card, CardBody, Heading } from '@aidkitorg/component-library'
import { useHistory } from 'react-router-dom'
import { useLocalizedStrings } from '../../Localization'

export const DashboardsPage = () => {
  const L = useLocalizedStrings()

  const history = useHistory()
    
  const headerContent = (
    <div>
      <Heading level="h1" className="m-0">{L.admin_panel.dashboards.dashboards}</Heading>
    </div>
  )

  const dashboardsEmptyState = (
    <div className="py-2 text-center text-gray-600 flex flex-col gap-y-4">
      <div>
        {L.admin_panel.dashboards.dashboards_empty_msg}
      </div>
      <div>
        <Button 
          onClick={(e) => {
            history.push('/admin-panel/my-dashboards/dashboard-builder')
          }}
        >
          {L.admin_panel.dashboards.create_new_dashboard}
        </Button>
      </div>
    </div>
  )
  return (
    <AdminPanelPage
      headerContent={headerContent}
    >

      <Card className="rounded-md">
        <CardBody>
          {dashboardsEmptyState}
        </CardBody>
      </Card>
    </AdminPanelPage>
  )
}